import { render, staticRenderFns } from "./rewardSerialCollect.vue?vue&type=template&id=5ad5b572&scoped=true&"
import script from "./rewardSerialCollect.vue?vue&type=script&lang=js&"
export * from "./rewardSerialCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad5b572",
  null
  
)

export default component.exports